import {FC} from 'react'
import {OrderCard, SummaryItem} from '../shared'
import {deliveryTypes} from 'app/constant'
import SummaryFooter from '../shared/SummaryFooter'
import sumBy from 'lodash/sumBy'
import values from 'lodash/values'
import {isShowCrv} from '../../helper'

const paymentStatusTypes = {
  pending: 'PENDING',
  failed: 'PAYMENT_FAILED',
}

interface Props {
  subtotalPrice: number
  totalTax: number
  totalDiscounts: number
  wineClubDiscounts: number
  shippingPrice: number
  orderDeliveryMethod: string
  totalPrice: number
  items: any[]
  shippingRate: any
  paymentMethod?: any
  title: string | any
  isFreeShipping?: boolean
  shippingTitle?: string
  discountTitle?: string
  wineClubDiscountTitle?: string
  financialStatus?: string | any
  totalTitle?: string
  tipAmount: number | any
  salesTax: number | any
  crv: number | any
  isCrv: boolean
  wineClubDiscountChild?: any
  taxTitle?: any
  totalAmountPaid?: any
  toolbar?: any
}

export const ViewOrderSummary: FC<Props> = ({
  totalTax,
  subtotalPrice,
  shippingPrice,
  orderDeliveryMethod,
  items,
  shippingRate,
  shippingTitle,
  title,
  isFreeShipping,
  tipAmount,
  salesTax,
  crv,
  isCrv,
  taxTitle,
  toolbar,
  ...props
}) => {
  if (values(paymentStatusTypes).includes(props.financialStatus)) {
    props.totalTitle = 'Additional Amount Charged'
  }

  return (
    <OrderCard
      title={title}
      className='py-5'
      toolbar={toolbar}
      isCustomFooter={<SummaryFooter {...props} />}
    >
      <SummaryItem title='Subtotal' value={subtotalPrice}>
        {items.length > 0 && <span className='text-muted'>{getItems(items)}</span>}
      </SummaryItem>
      {orderDeliveryMethod === deliveryTypes.ship && (
        <SummaryItem
          title={shippingTitle ?? isFreeShipping ? 'Shipping' : 'Shipping Price'}
          value={shippingPrice}
        >
          {isFreeShipping && shippingTitle ? (
            <span className='text-muted'>{shippingTitle}</span>
          ) : shippingRate && shippingRate.title ? (
            <span className='text-muted'>{shippingRate.title}</span>
          ) : (
            <span className='text-muted'>Custom Shipping Rate</span>
          )}
        </SummaryItem>
      )}
      {isShowCrv({isCrv, totalTax, crv}) && (
        <>
          <SummaryItem title='Sales Tax' value={salesTax ? salesTax : 0} className='text-muted' />
          <SummaryItem title='CRV Tax' value={crv ? crv : 0} className='text-muted' />
        </>
      )}
      <SummaryItem
        title={isShowCrv({isCrv, totalTax, crv}) ? 'Total Tax (Sales Tax + CRV Tax)' : 'Sales Tax'}
        value={totalTax}
      >
        {taxTitle}
      </SummaryItem>

      {tipAmount > 0 && <SummaryItem title='Tip Amount' value={tipAmount} />}
    </OrderCard>
  )
}

export default ViewOrderSummary

const getItems = (items: any[]) => {
  const total = sumBy(items, (item: any) => {
    if (item.quantity) {
      return parseInt(item.quantity)
    }
    return 0
  })
  return `${total} item${total > 1 ? 's' : ''}`
}
